import { render } from "./BackgroundProcesser.vue?vue&type=template&id=59136634&ts=true"
import script from "./BackgroundProcesser.vue?vue&type=script&lang=ts"
export * from "./BackgroundProcesser.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.11_vue@3.2.47_webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__